<script setup lang="ts">
import { CallbackTypes, GoogleLogin } from 'vue3-google-login';
import { GoogleAuth } from '@codetrix-studio/capacitor-google-auth';
import { useAuthStore } from '../../stores';
import LoginPanel from '../../components/Form/LoginPanel.vue';
import { ref } from 'vue';
import { useI18n } from 'petite-vue-i18n';
import { GOOGLE_CLIENT_ID } from '../../configs/api';
import googleIcon from '../../assets/icons/google.svg';
import { TEXT } from '../../configs/text';
import { Capacitor } from '@capacitor/core';

const auth = useAuthStore()
const errorCode = ref<string | undefined>('')

async function handleWebCallBack(e: CallbackTypes.CredentialPopupResponse) {
    errorCode.value = ''
    const googleToken = e.credential
    errorCode.value = await auth.teacherLogin(googleToken)
}

if (Capacitor.getPlatform() === 'android') {
    GoogleAuth.initialize({
        clientId: GOOGLE_CLIENT_ID,
        scopes: ['profile', 'email']
    })
}

async function handleAndroidLogin() {
    errorCode.value = ''
    try {
        await GoogleAuth.signOut()
        const res = await GoogleAuth.signIn()
        errorCode.value = await auth.teacherLogin(res.authentication.idToken)
    } catch {
        errorCode.value = TEXT.login_failed
    }
}

const { t } = useI18n()
</script>

<template>
    <LoginPanel>
        <div class="flex mx-auto justify-center">
            <GoogleLogin v-if="Capacitor.getPlatform() === 'web'" :clientId="GOOGLE_CLIENT_ID"
                :callback="handleWebCallBack"></GoogleLogin>
            <div v-if="Capacitor.getPlatform() === 'android'"
                class="flex items-center py-2 px-3 border-[1px] border-neutral-200 rounded gap-2 cursor-pointer"
                @click="handleAndroidLogin">
                <img :src="googleIcon" class="size-5" />
                <span class="shrink-0 text-sm">{{ t(TEXT.sign_in_with_google) }}</span>
            </div>
        </div>
        <div v-if="errorCode" class="text-red-500 text-center mt-3">{{ t(errorCode) }}</div>
    </LoginPanel>
</template>